import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[appDraggable]',
  host: {
        'class': 'draggable',
        '[class.dragging]': 'dragging',
    },
  standalone: false
})
export class DraggableDirective {
  @Input() dragDirection: 'horizontal' | 'vertical' | 'both' = 'both';

  @Output() dragStart = new EventEmitter<DraggableEvent>();
  @Output() dragMove = new EventEmitter<DraggableDeltaEvent>();
  @Output() dragEnd = new EventEmitter<DraggableEvent>();

  dragging = false;
  dragX = 0;
  dragY = 0;

  constructor(
    public element: ElementRef<HTMLElement>) {
  }

  @HostListener('mousedown', ['$event'])
  onMouseDown(event: MouseEvent) {
    if (event.button === 0) {
      this.dragging = true;

      this.dragX = event.pageX;
      this.dragY = event.pageY;

      this.dragStart.emit({
        dragX: this.dragX,
        dragY: this.dragY
      });
    }
  }

  @HostListener('window:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {
    if (this.dragging) {
      let canResizeBoth = this.dragDirection == 'both';
      let canResizeX = canResizeBoth || (this.dragDirection == 'horizontal');
      let canResizeY = canResizeBoth || (this.dragDirection == 'vertical');

      let dx = canResizeX ? (event.pageX - this.dragX) : 0;
      let dy = canResizeY ? (event.pageY - this.dragY) : 0;

      this.dragX = event.pageX;
      this.dragY = event.pageY;

      this.dragMove.emit({
        dragX: this.dragX,
        dragY: this.dragY,
        dx, dy
      });
    }
  }

  @HostListener('window:mouseup', ['$event'])
  onMouseUp(event: MouseEvent) {
    if (event.button === 0) {
      if (this.dragging) {
        this.dragX = event.pageX;
        this.dragY = event.pageY;

        this.dragging = false;

        this.dragEnd.emit({
          dragX: this.dragX,
          dragY: this.dragY
        });
      }
    }
  }
};

export interface DraggableEvent {
  dragX: number;
  dragY: number;
};

export interface DraggableDeltaEvent {
  dragX: number;
  dragY: number;
  dx: number;
  dy: number;
};
